import Button from '@mui/material/Button';
import ClearIcon from '@mui/icons-material/Clear';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';
import React from 'react';
import PropTypes from 'prop-types';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import {ThemeProvider} from '@mui/material';
import {orangeTheme} from '../../_theme';
import LinearProgress from '@mui/material/LinearProgress';
import {SUBMISSION_STATUS} from '../../../utils/constants';
import {useProperty} from '@olympeio/core';
import {BrickContext} from 'olympe';

/**
 *
 * @param {DenyApproveBtn.propTypes} props
 * @return {JSX.Element}
 */
export function DenyApproveBtn(props) {
    const useRequestStore = requestStores.get(props.prTag);
    const actionButtonState = useRequestStore((state) => state.actionButtonState);

    const submissionStatus = useProperty(props.context, 'Submission status', false);

    return (
        <>
            <div className={'pr-editor-buttons'}>
                <Button
                    style={{backgroundColor: '#FF0000', color: 'white', borderColor: '#FF0000', marginBottom: '2vh'}}
                    variant={'outlined'}
                    onClick={props.handleClickOnDeny}
                    startIcon={<ClearIcon/>}>
                    Deny
                </Button>
                <LoadingButton
                    data-cy={'Approve_button'}
                    style={{backgroundColor: '#009100', color: 'white', borderColor: '#009100', marginBottom: '2vh'}}
                    variant={'outlined'}
                    onClick={() => {
                        props.handleClickOnApprove();
                    }}
                    endIcon={<SendIcon />}
                    loading={props.loading}
                    loadingPosition={'end'}>
                    Approve
                </LoadingButton>
            </div>
            {actionButtonState.loading &&
                <>
                    <div className={'pr-editor-buttons-loading'}>{SUBMISSION_STATUS[submissionStatus]}</div>
                    <ThemeProvider theme={orangeTheme}>
                        <LinearProgress variant={'determinate'} value={Math.trunc(100 * Number(submissionStatus.slice(0, 1)) / Object.keys(SUBMISSION_STATUS).length)} style={{width: '100%'}}/>
                    </ThemeProvider>
                </>
            }
        </>
    );
}

DenyApproveBtn.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string,
    handleClickOnDeny: PropTypes.func.isRequired,
    handleClickOnApprove: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};
